// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"e81ead04","158":"393fa0fc","227":"b2691947","399":"d478013c","525":"80609127","588":"4a83128f","624":"770068ac","654":"26d5a092","787":"5ede67d5","834":"3f694f40"}[chunkId] + ".chunk.js";
};